import React from "react";
import EditReasonForCallModal from "../../../apps/Queue/EditReasonForCallModal";
import EditReturnPhoneModal from "../../../apps/Queue/EditReturnPhoneModal";
import { formatPhoneNumber, parseBookingPhone } from "./phoneNumber";
import { notificationDestinationSummary } from "./notificationDestination";
import { updateAppointmentDetails } from "../../../api/Scheduling/appointments";

function visitRecord(appointment, encounter) {
  if (encounter) return encounter;
  const context = appointment?.bookingContext;
  if (!context) return null;
  return { intakeQuestions: { intakeReason: context.reason, callerNumber: context.phone, callerNumberExt: context.ext, preferredChannel: context.preferredChannel } };
}

export function AppointmentVisitEditor({ field, appointment, organizationRef, encounter, onHide, onSaved }) {
  const data = visitRecord(appointment, encounter);
  const onSubmitOverride = !encounter && appointment?.bookingContext ? (patch) => updateAppointmentDetails({
    organizationRef, appointmentId: appointment.appointmentId, version: appointment.version,
    bookingContext: { ...appointment.bookingContext, ...patch },
  }) : undefined;
  if (field === "reason") return <EditReasonForCallModal data={data} onShow onHide={onHide} onSuccess={onSaved} onSubmitOverride={onSubmitOverride} dialogClassName="custom-dialog scheduling-dialog" />;
  if (field === "phone") return <EditReturnPhoneModal data={data} onShow onHide={onHide} onSuccess={onSaved} onSubmitOverride={onSubmitOverride} dialogClassName="custom-dialog scheduling-dialog" formattedPhone />;
  return null;
}

export default function AppointmentVisitDetails({ appointment, encounter, loading, error, onReload, onEdit, disabled }) {
  const record = visitRecord(appointment, encounter);
  const intake = record?.intakeQuestions || {};
  const { phone, ext } = parseBookingPhone(intake.callerNumber, intake.callerNumberExt);

  return (
    <section className="schedule-booking-details" aria-labelledby="appointment-visit-details-title">
      <h3 id="appointment-visit-details-title" className="appointment-visit-title">Visit details</h3>
      {loading ? <p role="status">Loading visit details…</p> : error ? (
        <p className="schedule-error" role="alert">{error} <button type="button" className="schedule-text-button" onClick={onReload}>Retry</button></p>
      ) : !record ? <p>No linked encounter.</p> : (
        <dl className="appointment-visit-fields">
          <div><dt>Reason for visit</dt><dd>{intake.intakeReason || "Not recorded"}</dd><button type="button" className="schedule-text-button" disabled={disabled} aria-label="Edit reason for visit" onClick={() => onEdit("reason")}>Edit</button></div>
          <div><dt>Return phone number</dt><dd>{phone ? `${formatPhoneNumber(phone)}${ext ? ` ext ${ext}` : ""}` : "Not recorded"}</dd><button type="button" className="schedule-text-button" disabled={disabled} aria-label="Edit return phone number" onClick={() => onEdit("phone")}>Edit</button></div>
          <div><dt>Appointment by</dt><dd>{intake.preferredChannel === "video/chat" ? "Video / chat" : intake.preferredChannel === "phone" ? "Phone" : "Not recorded"}</dd></div>
          {appointment?.bookingContext ? <div><dt>Appointment notifications</dt><dd>{notificationDestinationSummary(appointment.bookingContext)}</dd></div> : null}
        </dl>
      )}
    </section>
  );
}
